const siteConfig = {
  brandName: "tworvella",
  displayName: "TWORVELLA",
  logo: { wordmark: "TWORVELLA", symbol: "T" },
  tagline: "Clothes for repeat days.",
  description:
    "A focused wardrobe of tactile layers, breathable tailoring and easy everyday shapes selected for repeated wear.",
  business: {
    region: "Canada",
    address: "",
    locale: "en-CA",
    language: "English",
    currency: "CAD",
    timezone: "",
  },
  contact: {
    email: "customs@tworvella.monster",
  },
  commerce: {
    standardShipping: 9.99,
    discountCode: "TWORVELLA10",
    discountRate: 0.1,
    orderPrefix: "TRV",
    seasonLabel: "Everyday collection",
    paymentPlatform: "Stripe",
  },
  checkout: {
    countries: [
      "Australia", "Austria", "Belgium", "Canada", "Croatia", "Cyprus",
      "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Germany",
      "Greece", "Ireland", "Italy", "Japan", "Latvia", "Lithuania", "Luxembourg",
      "Malta", "Netherlands", "New Zealand", "Norway", "Poland", "Portugal",
      "Singapore", "Slovakia", "Slovenia", "South Korea", "Spain", "Sweden",
      "Switzerland", "United Kingdom", "United States",
    ],
  },
  storage: {
    cart: "tworvella-cart",
    wishlist: "tworvella-wishlist",
    discount: "tworvella-discount",
    pendingOrder: "tworvella-pending-order",
  },
};

export const formatPrice = (value) => {
  const numericValue = Number(value) || 0;

  return new Intl.NumberFormat(siteConfig.business.locale, {
    style: "currency",
    currency: siteConfig.business.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default siteConfig;
